import { createContext, useContext } from "react";

/**
 * Feb-2026 Iter 28 — BasicsCollapseContext
 *
 * Wenn der Nutzer eine der „darunter liegenden" Top-Level-Sections öffnet
 * (Ausstattung & Zubehör, Service & Wartung, Bilder & Video,
 *  Preise & Vermittlungsprovision, Werbung & Reichweite,
 *  Disposition / Portal-Transaktion …), soll Fahrzeug-Stammdaten automatisch
 * zugeklappt werden — damit der Fokus auf die gerade gewählte Section liegt.
 *
 * Anwendung:
 *   const { closeBasicsIfOpen } = useBasicsCollapse();
 *   <CollapsibleCard onOpenChange={(open) => { if (open) closeBasicsIfOpen(); ... }} />
 */
export const BasicsCollapseContext = createContext({ closeBasicsIfOpen: () => {} });

export function useBasicsCollapse() {
    return useContext(BasicsCollapseContext);
}
